import React from "react";
import { IconButton, Icon } from "@chakra-ui/react";
import { IoCheckmarkSharp, IoBan } from "react-icons/io5";

export const ActiveButton = ({ isActive, ...rest }) => {
  return (
    <IconButton size="xs" colorScheme={isActive ? "green" : "gray"} icon={<Icon as={isActive ? IoCheckmarkSharp : IoBan} />} {...rest} />
  );
};
